<script>

	import { mapState } from 'vuex'

	import Page from '@/containers/Page/Page'
	import LoginBox from '@/components/LoginBox/LoginBox'

	import './style.scss'

	export default {
		name: 'login',
		components: {
			Page,
			LoginBox,
		},
		data: () => ({
			email: '',
			password: '',
		}),
		created () {
			if (this.isLoggedIn === true) this.$router.push('/')
		},
		computed: {
			...mapState({
				'isLoggedIn': state => state.user.isLoggedIn
			})
		}
	}

</script>

<template>
	<Page class='login'>
		<LoginBox />
	</Page>
</template>



// WEBPACK FOOTER //
// src/flows/Login/Login.vue